// src/services/notificationService.js
import { getToken, onMessage } from "firebase/messaging";
import {
  doc, updateDoc, collection, addDoc,
  serverTimestamp, query, where, onSnapshot,
} from "firebase/firestore";
import { db, getMessagingInstance } from "./firebase";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// ── ١. طلب الإذن وحفظ FCM Token ──────────────────────────────
export async function requestNotificationPermission(userId) {
  try {
    if (!("Notification" in window)) return null;
    if (!("serviceWorker" in navigator)) return null;
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;
    const messaging = await getMessagingInstance();
    if (!messaging || !VAPID_KEY) return null;
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token && userId) {
      await updateDoc(doc(db, "users", userId), {
        fcmToken: token, fcmTokenUpdatedAt: serverTimestamp(),
      });
    }
    return token;
  } catch (err) {
    console.warn("FCM setup error:", err.message);
    return null;
  }
}

// ── ٢. Foreground handler — لا يعرض إشعار (Service Worker يعرض) ─
let _foregroundUnsub = null;

export async function setupForegroundNotifications() {
  if (_foregroundUnsub) return;
  const messaging = await getMessagingInstance();
  if (!messaging) return;
  // لا نعرض new Notification() هنا إطلاقاً
  // Service Worker هو المصدر الوحيد لعرض الإشعار
  // Bell icon يتحدث تلقائياً من Firestore subscription
  _foregroundUnsub = onMessage(messaging, (payload) => {
    console.log("[FCM foreground]", payload.data?.type);
  });
}

export function cleanupForegroundNotifications() {
  if (_foregroundUnsub) { _foregroundUnsub(); _foregroundUnsub = null; }
}

// ── ٣. حفظ إشعار in-app → Cloud Function ترسل FCM تلقائياً ──
export async function saveNotification(userId, { title, body, type, tripId }) {
  await addDoc(collection(db, "notifications"), {
    userId, title, body, type,
    tripId: tripId || null,
    read: false,
    createdAt: serverTimestamp(),
  });
}

// ── ٤. Bell icon subscription ──────────────────────────────────
export function subscribeNotifications(userId, callback) {
  const q = query(
    collection(db, "notifications"),
    where("userId", "==", userId),
    where("read", "==", false)
  );
  return onSnapshot(q,
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    err => console.error("notifications:", err.code)
  );
}

// ── ٥. تعليم كمقروء ───────────────────────────────────────────
export async function markNotificationRead(notifId) {
  await updateDoc(doc(db, "notifications", notifId), { read: true });
}
